/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const tokenDeliveryOutcomeDataSchema = z.object({
	tokenId: z.string(),
	channels: z.array(
		z.object({
			channel: z.union([z.literal('email'), z.literal('whatsapp')]),
			outcome: z.union([z.literal('sent'), z.literal('skipped'), z.literal('failed')]),
			reason: z.union([
				z.literal('not_opted_in'),
				z.literal('no_email_address'),
				z.literal('no_email_body'),
				z.literal('whatsapp_not_configured'),
				z.literal('whatsapp_template_language_missing'),
			]).nullable(),
		}),
	),
})

export type TokenDeliveryOutcomeDataSchema = z.infer<typeof tokenDeliveryOutcomeDataSchema>
